export default {
  newDesign: true,
  parameters: {
    landing_id: "IdQOf",
    segment: 4,
  },
  downtimeUrl: "https://id6.kodland.tech",
  ageRules: {
    min: 5,
    max: 17,
  },
  title: "Kelas Online Desain Grafis untuk Anak 8–17 Tahun | Kodland",
  startPage: {
    title: "Daftar kelas percobaan sekarang dan dapatkan kursus lengkap GRATIS!",
    subtitle:
      "Dalam pelajaran pertama, anak Anda akan belajar dasar-dasar pemrograman bersama guru dan membuat proyek pertamanya sendiri.",
    button: "Terima 🚀",
    backgroundColor: "#001C32",
    whiteLogo: true,
    titleStyle: { color: "white" },
    subtitleStyle: { color: "white" },
    image: {
      url: "/welcome/indonesia_offer_gd.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/indonesia_offer_gd.png",
      style: {
        width: "100%",
      },
    },
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Terima kasih atas kepercayaan Anda pada platform pendidikan kami!",
    subtitle:
      "Sayangnya, tablet atau ponsel tidak sesuai untuk mengikuti pelajaran kami. Kami akan sangat senang melihat Anda di kelas berikutnya!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Untuk mengikuti kelas gratis ini, Anda perlu menggunakan komputer atau laptop (bukan HP) dengan koneksi internet stabil. Apakah Anda memiliki komputer/laptop di rumah?",
      answers: [
        "💻 Ya, kami memiliki komputer/laptop di rumah",
        {
          answer: "❌ Tidak, kami tidak memiliki komputer/laptop di rumah",
          stopAnswer: true,
        },
      ],
    },
    2: {
      title: "Berapa usia anak Anda?",
      type: "age",
      subtitle: "Kami akan memilih kursus yang paling sesuai dengan usia anak Anda.",
      button: "",
    },
    3: {
      title: "Tinggal satu langkah lagi 🎉",
      typeInfo: "congrats",
      subtitle: "Buka potensi kreatif anak Anda dalam desain grafis! 📅 Jadwalkan kelas",
      button: "📆 Pesan",
    },
    4: {
      title: "Daftar untuk kelas uji coba gratis",
      type: "one-page-contacts",
      subtitle:
        "Mari saling mengenal, cari tahu apa saja yang akan kita pelajari, dan seperti apa proses belajarnya nanti.",
      button: "Lanjutkan 🔥",
    },
    5: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    6: {
      title: "Tinjau detail berikut untuk menyelesaikan pendaftaran ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Harap diperhatikan bahwa Anda akan membutuhkan komputer atau laptop yang berfungsi untuk pelajaran, dan Anda harus menemani anak Anda selama kelas berlangsung. Mohon diingat bahwa pelajaran ini bersifat individual dan personal.",
      button: "Selanjutnya bagaimana?",
    },
    7: {
      title: "Sebelum kelas uji coba, periksa email dan WhatsApp Anda 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Kami akan mengirimkan pengingat 24 jam sebelum kelas dimulai dan meminta Anda untuk mengonfirmasikan kehadiran Anda 2 jam sebelum kelas dimulai. Sangat penting untuk tetap berkomunikasi agar kelas tidak dibatalkan.",
      button: "Selanjutnya bagaimana?",
    },
    8: {
      title: "Kelas akan diadakan di platform kami 💻",
      typeInfo: "classroom",
      subtitle:
        "Anda akan menerima tautan dan kode unik melalui WhatsApp dan email. Klik saja tautannya, dan Anda akan langsung diarahkan ke kelas. Tidak perlu aplikasi tambahan, tidak perlu mengunduh apa pun.",
      button: "Mengerti ✅",
    },
  },
};
